/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import {Grommet, Box} from "grommet"
import "fontsource-dm-sans/400.css"
import "fontsource-dm-sans/500.css"

import po3theme from "../themes/po3Theme.json"
import "./layout.css"

const Layout = ({ children }) => {

  return (
    <Grommet theme={po3theme}>
        <main>{children}</main>
        <Box pad={{vertical: "medium"}} align="center" background="black">
          © {new Date().getFullYear()} Po3
        </Box>
    </Grommet>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
